export default __webpack_public_path__ + "static/media/icono-autotoma-gris.bddb34ac.svg";